import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSupportTicketMessage({
  enabled = true,
  code,
  page = 1,
}: {
  enabled?: boolean;
  code: string;
  page?: number;
}) {
  const api = useApi();

  return useQuery({
    queryKey: [`supportTicket/${code}/message`, page], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `supportTicket/${code}/message`,
        params: { page },
      });
      return res;
    },
    enabled,
  });
}
